module.exports = __webpack_public_path__ + "img/gaelicfootball.63e8dcf9.svg";